/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_LaunchInputs */

const en_gc_editor_launch = /** @type {(inputs: Gc_Editor_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch GridCraft`)
};

const zh_gc_editor_launch = /** @type {(inputs: Gc_Editor_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动 GridCraft`)
};

/**
* | output |
* | --- |
* | "Launch GridCraft" |
*
* @param {Gc_Editor_LaunchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_launch = /** @type {((inputs?: Gc_Editor_LaunchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_LaunchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_launch(inputs)
	return zh_gc_editor_launch(inputs)
});
export { gc_editor_launch as "gc.editor.launch" }